import { graphqlRequest, restRequest } from "../../services/apiService";

export const CreateTourAPI = async (tourData) => {
  try {
    const query = `
      mutation CreateTour($tourName: String!, $companyId: String!, $companyName: String!, $distance: String!, $checkpoints: [CheckpointInput!], $status: String) {
        createTour(tourName: $tourName, companyId: $companyId, companyName: $companyName, distance: $distance, checkpoints: $checkpoints, status: $status) {
          id
          tourName
          companyId
          companyName
          distance
          status
          checkpoints {
            id
            sequence
            checkpointName
            location
            qrcode
            tourId
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
    `;

    const data = await graphqlRequest(query, tourData);
    return data.createTour;
  } catch (error) {
    console.error("Error creating tour:", error);
    throw error;
  }
};

export const GetAllTourAPI = async () => {
  try {
    const query = `
      query Query {
        tours {
          id
          tourName
          companyId
          companyName
          status
          distance
          companyDetails {
            id
            company
            city
            zipCode
            address
            state
            industry
            weeklyHours
            clientName
            clientType
            streetAddress
          }
          createdAt
          updatedAt
          checkpoints {
            id
            sequence
            checkpointName
            location
            qrcode
            tourId
            createdAt
            updatedAt
          }
        }
      }
    `;

    const data = await graphqlRequest(query, {});
    return data.tours;
  } catch (error) {
    console.error("Error fetching tours:", error);
    throw error;
  }
};
export const DeleteAllTourAPI = async (tourId) => {
  try {
    const query = `
      mutation DeleteTour($deleteTourId: ID!) {
        deleteTour(id: $deleteTourId)
      }
    `;

    const data = await graphqlRequest(query, { deleteTourId: tourId });
    return data.deleteTour;
  } catch (error) {
    console.error("Error deleting tour:", error);
    throw error;
  }
};

export const GetTourByIdAPI = async (tourId) => {
  try {
    const query = `
      query Tour($tourId: ID!) {
        tour(id: $tourId) {
          id
          tourName
          companyId
          companyName
          status
          distance
          createdAt
          updatedAt
          checkpoints {
            id
            sequence
            checkpointName
            location
            qrcode
            tourId
            createdAt
            updatedAt
          }
        }
      }
    `;

    const data = await graphqlRequest(query, { tourId: tourId });
    return data.tour;
  } catch (error) {
    console.error("Error fetching tour:", error);
    throw error;
  }
};

export const UpdateTourAPI = async (tourData) => {
  try {
    const query = `
      mutation UpdateTour($updateTourId: ID!, $tourName: String, $companyId: String, $companyName: String, $distance: String, $status: String, $checkpoints: [CheckpointInput!]) {
        updateTour(id: $updateTourId, tourName: $tourName, companyId: $companyId, companyName: $companyName, distance: $distance, status: $status, checkpoints: $checkpoints) {
          id
          tourName
          companyId
          companyName
          status
          distance
          checkpoints {
            id
            sequence
            checkpointName
            location
            qrcode
            tourId
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
    `;

    const data = await graphqlRequest(query, tourData);
    return data.updateTour;
  } catch (error) {
    console.error("Error updating tour:", error);
    throw new Error(error.message || "Failed to update tour");
  }
};


export const CreateCheckoutAPI = async (checkoutData) => {
  try {
    const query = `
      mutation CreateCheckpoint($tourId: ID!, $checkpointName: String!, $location: String!, $sequence: String!, $qrcode: String) {
        createCheckpoint(tourId: $tourId, checkpointName: $checkpointName, location: $location, sequence: $sequence, qrcode: $qrcode) {
          id
          sequence
          checkpointName
          location
          qrcode
          tourId
          createdAt
          updatedAt
        }
      }
    `;

    const data = await graphqlRequest(query, checkoutData);
    return data.createCheckpoint;
  } catch (error) {
    console.error("Error creating checkpoint:", error);
    throw new Error(error.message || "Failed to create checkpoint");
  }
};



//  add checkpoint => await CreateCheckoutAPI(checkoutData)
// Variable => {
//   "tourId": "nullasa",
//   "checkpointName": "asdasdasd",
//   "location": "nullll",
//   "qrcode": "null",
//   "sequence": "null"
// }



//  Update checkpoint => await CreateCheckoutAPI(checkoutData)
// {
//   "updateCheckpointId": null,
//   "sequence": null,
//   "checkpointName": null,
//   "location": null,
//   "qrcode": null
// }


//  Delete checkpoint => mutation DeleteCheckpoint($deleteCheckpointId: ID!) {
//   deleteCheckpoint(id: $deleteCheckpointId)
// }

export const IsAssignedTourAPI = async (tourId) => {
  try {
    const response = await restRequest('POST', '/api/tour/isAssignedTour', { id: tourId });
    // Response structure: { statusCode, message, data: { tourId, isAssigned, assignedReports } }
    return response;
  } catch (error) {
    console.error("Error checking tour assignment status:", error);
    throw error;
  }
};
